export default {
  "t-engagement-management": "Activity Mgmt",
  "t-engagement-overview": "Activity Overview",
  "t-overview": "Overview",
  "t-device-model": "Device Model",
  "t-sn-range": "SN Range",
  "t-start-number": "Start No.",
  "t-end-number": "End No.",
  "t-complete-sn-range-required": "Please enter the complete SN query range",
  "t-filter": "Filter",
  "t-activation-rate": "Activation Rate",
  "t-online-rate": "Online Rate",
  "t-usage-rate": "Usage Rate",
  "t-high-frequency-activity-rate": "High Activity Rate",
  "t-silent-devices": "Silent Devices",
  "t-activated-devices-count": "{count} activated",
  "t-devices-count": "{count} devices",
  "t-device-unit": "devices",
  "t-compared-with-last-week": "vs last week",
  "t-trend": "Trend",
  "t-trend-analysis": "Trend Analysis",
  "t-recent-7-days": "Last 7 Days",
  "t-recent-30-days": "Last 30 Days",
  "t-recent-7-days-metrics-trend": "Last 7 days metrics trend",
  "t-recent-30-days-metrics-trend": "Last 30 days metrics trend",
  "t-total-uptime": "Total Uptime",
  "t-total-uptime-list": "Device Total Uptime List",
  "t-total-uptime-list-desc": "Statistics for each device's total connection duration with TMS and multi-signal activity",
  "t-heartbeat-statistics": "Heartbeat Statistics",
  "t-heartbeat": "Heartbeat Statistics",
  "t-heartbeat-statistics-list": "Device Active Signal Statistics List",
  "t-heartbeat-statistics-list-desc": "Per-device multi-signal activity details (card swipes or traffic; meeting any threshold counts as active)",
  "t-heartbeat-signal": "Active Signal",
  "t-card-swipe-count": "Card Swipes",
  "t-print-count": "Prints",
  "t-print-distance": "Print Distance",
  "t-business-traffic": "Business Traffic",
  "t-screen-on-duration": "Screen-on Time",
  "t-active-time": "Activation Time",
  "t-active-time-list": "Device Activation Time List",
  "t-active-time-list-desc": "Records the time when each device completed activation and first came online",
  "t-days-from-now": "Days Ago",
  "t-days-ago": "{count} days ago",
  "t-inactive-device-alert": "Silent Device Alert",
  "t-inactive-device-alert-list": "Silent Device Alert List",
  "t-inactive-device-alert-list-desc": "Devices that had active signals last month but have no active signals this month and insufficient online duration",
  "t-idle-device-alert": "Idle Device Alert",
  "t-idle-device-alert-list": "Idle Device Alert List",
  "t-idle-device-alert-list-desc": "Idle device alert list for devices that are online but have no active signals during the statistical period (L2 multi-signal OR: card swipe/printing/traffic/screen on)",
  "t-idle-devices-total": "Total Idle Devices",
  "t-idle-days": "Idle Days",
  "t-pending-activation": "Pending Activation",
  "t-pending-activation-list": "Pending Activation List",
  "t-pending-activation-list-desc": "Devices entered into the TMS system but never activated online, sorted by entry days (older records need more attention)",
  "t-pending-activation-total": "Total Pending Activation Devices",
  "t-threshold-settings": "Threshold Settings",
  "t-edit-threshold-settings": "Edit Threshold Settings",
  "t-threshold-settings-list": "Threshold Settings List",
  "t-threshold-settings-list-desc": "Manage threshold parameters for determining activity levels in the system",
  "t-threshold-config-name": "Config Name",
  "t-threshold-type": "Threshold Type",
  "t-threshold-value": "Threshold",
  "t-threshold-type-online-duration": "Online Duration",
  "t-threshold-type-silent-days": "Silent Days",
  "t-threshold-type-idle-detection": "Idle Detection",
  "t-threshold-type-card-swipe-count": "Card Swipe Count",
  "t-threshold-type-unactivated-days": "Unactivated Days",
  "t-threshold-type-screen-on-duration": "Screen-on Duration",
  "t-threshold-type-business-traffic": "Business Traffic",
  "t-online-duration-threshold": "Online Duration Threshold",
  "t-silent-device-threshold": "Silent Device Threshold",
  "t-idle-device-threshold": "Idle Device Threshold",
  "t-high-frequency-active-threshold": "High Activity Threshold",
  "t-unactivated-reminder-threshold": "Unactivated Reminder Threshold",
  "t-screen-on-duration-threshold": "Screen-on Duration Threshold",
  "t-business-traffic-threshold": "Business Traffic Threshold",
  "t-threshold-value-24h": "24h",
  "t-threshold-value-7-days": "7 days",
  "t-threshold-value-3-days": "3 days",
  "t-threshold-value-50-times-day": "50 times/day",
  "t-threshold-value-30-days": "30 days",
  "t-threshold-value-2h": "2h",
  "t-threshold-value-10mb-day": "10MB/day",
  "t-online-duration-threshold-desc": "Devices are considered active when continuous online duration exceeds this threshold",
  "t-silent-device-threshold-desc": "Devices are considered silent when no active signal is detected after this number of days",
  "t-idle-device-threshold-desc": "Devices are considered idle when online with no business activity beyond this number of days",
  "t-high-frequency-active-threshold-desc": "Devices are considered highly active when daily card swipes exceed this threshold",
  "t-unactivated-reminder-threshold-desc": "A reminder is triggered when devices remain unactivated after this number of days since entry",
  "t-screen-on-duration-threshold-desc": "Devices are counted as active when daily screen-on duration exceeds this threshold",
  "t-business-traffic-threshold-desc": "Devices are counted as active when daily business traffic exceeds this threshold",
  "t-pending-days": "Entry Days",
  "t-activation-analytics": "Activation Analytics",
  "t-activation-analytics-list": "Partner Activation Analytics",
  "t-activation-analytics-list-desc": "Overview of each partner's device activation status, with support for sorting by activation rate",
  "t-activation-analytics-total": "Total Activation Analytics",
  "t-activation-rate-rank": "Activation Rate",
  "t-partner-count": "Partners",
  "t-average-activation-rate": "Average Activation Rate",
  "t-highest-activation-rate": "Highest Activation Rate",
  "t-lowest-activation-rate": "Lowest Activation Rate",
  "t-network-devices": "Online Devices",
  "t-activated": "Activated",
  "t-unactivated": "Unactivated",
  "t-entry-time": "Entry Time",
  "t-inventory-estimation": "Inventory Estimation",
  "t-latest-heartbeat": "Latest Heartbeat",
  "t-suspected-in-inventory": "Suspected In Inventory",
  "t-long-term-not-powered-on": "Long-term Not Powered On",
  "t-contact-partner-for-verification": "Contact partner for verification",
  "t-idle-duration": "Idle Duration",
  "t-hour-unit": "h",
  "t-idle-over-72-hours": "Idle ≥72 Hours",
  "t-idle-24-72-hours": "Idle 24-72 Hours",
  "t-idle-under-24-hours": "Idle <24 Hours",
  "t-continuously-online-no-business": "Continuously online with no business",
  "t-follow-up-business-opening-status": "Follow up business opening status",
  "t-possible-temporary-maintenance": "Possibly temporary maintenance",
  "t-current-online-status": "Current Online Status",
  "t-warning-level": "Warning Level",
  "t-warning-high": "High",
  "t-warning-medium": "Medium",
  "t-warning-low": "Low",
  "t-contact-merchant": "Contact Merchant",
  "t-observe": "Observe",
  "t-last-month-active-signal": "Last Month Active Signal",
  "t-this-month-active-signal": "This Month Active Signal",
  "t-this-month-online-duration": "This Month Online Duration",
  "t-total-online": "Total Online",
  "t-last-active": "Last Online Time",
  "t-total-devices-count": "Total {count} devices",
  "t-silent-devices-total": "Total Silent Devices",
  "t-risk-critical-days": "Critical (≥30 days)",
  "t-risk-medium-days": "Medium (14-29 days)",
  "t-risk-watch-days": "Watch (7-13 days)",
  "t-suspected-fault-or-permanent-offline": "Suspected fault or permanently offline",
  "t-merchant-status-follow-up-needed": "Merchant status follow-up needed",
  "t-continuous-monitoring": "Continuous monitoring",
  "t-silent-days": "Silent Days",
  "t-day-unit": "days",
  "t-last-card-swipe-time": "Last Card Swipe Time",
  "t-risk-level": "Risk Level",
  "t-risk-critical": "Critical",
  "t-risk-medium": "Medium",
  "t-risk-watch": "Watch",
  "t-follow-up": "Follow Up",
  "t-view-threshold-settings": "View Threshold Settings",
  "t-close": "Close",
  "t-fetch-failed": "Failed to fetch data",
  "t-save-success": "Saved successfully",
  "t-save-failed": "Failed to save",
  "t-threshold-value-range": "Threshold value must be between 1 and 100",
}
